module.exports = __webpack_public_path__ + "static/media/9th-pawn.ac0f6d9f.jpg";